import { AbstractControl } from '@angular/forms';
import { DOCUMENT_FORMAT_TYPE } from '../enums/document-format-type.enum';
import { DOCUMENT_STATE_TYPE } from '../enums/document-state-type.enum';

export const DOCUMENT_FORMAT = [
  { id: DOCUMENT_FORMAT_TYPE.PDF, displayValue: 'PDF' },
  { id: DOCUMENT_FORMAT_TYPE.WORD, displayValue: 'Word' },
];

export enum RequestDocumentTypes {
  COVER_LETTER_CBF = 'COVER_LETTER_CBF',
  COVER_LETTER_CBL = 'COVER_LETTER_CBL',
  GLOBAL_NOTE = 'GLOBAL_NOTE',
  PIB = 'PIB',
  TECHNICAL_ANNEX = 'TECHNICAL_ANNEX',
  TMG = 'TMG',
}

export const DOC_TYPES = [
  {
    id: RequestDocumentTypes.TECHNICAL_ANNEX,
    displayValue: 'Technical Annex to Final Terms',
  },
  { id: RequestDocumentTypes.TMG, displayValue: 'TMG Form' },
];

export const RATES_PRODUCTS_DOC_TYPES = [
  {
    id: RequestDocumentTypes.COVER_LETTER_CBF,
    displayValue: 'Cover Letter CBF',
  },
  {
    id: RequestDocumentTypes.COVER_LETTER_CBL,
    displayValue: 'Cover Letter CBL',
  },
  { id: RequestDocumentTypes.GLOBAL_NOTE, displayValue: 'Global Note' },
  { id: RequestDocumentTypes.PIB, displayValue: 'PIB' },
];

export const DOCUMENT_STATE = [
  { id: DOCUMENT_STATE_TYPE.INDICATIVE, displayValue: 'Indicative' },
  { id: DOCUMENT_STATE_TYPE.FINAL, displayValue: 'Final' },
];

export interface DocumentModalResult {
  language: string;
  docFormat: string;
  type?: string;
  documentState: string;
  subtype?: string;
}

export type DocumentModalResultForm = {
  [k in keyof DocumentModalResult]: AbstractControl<DocumentModalResult[k]>;
};
